import gsap from "gsap";
import { isMobile } from "..";
const body = document.querySelector("body"), header = document.querySelector("header"), burger = document.getElementById("burger"), menu = document.getElementById("menu"), scroll_up = document.getElementById("scroll-up");
let menu_state = false, lastScrollTop = window.scrollY, offset = 200;
const open_menu = () => {
    body.style.overflow = "clip";
    gsap.timeline()
        .to(menu, { autoAlpha: 1, duration: 1, ease: "expo.out" })
        .to(["#line_1"], { y: 12 }, "0")
        .to(["#line_3"], { y: -12 }, "0")
        .to(["#line_2"], { autoAlpha: 0 }, "0")
        .to(["#line_1"], { rotate: 45, transformOrigin: "center" }, "0.25")
        .to(["#line_3"], { rotate: -45, transformOrigin: "center" }, "0.25");
};
const close_menu = () => {
    body.style.overflow = "inherit";
    gsap.timeline()
        .to(menu, { autoAlpha: 0 }, "0")
        .to(["#line_1"], { rotate: 0 }, "0")
        .to(["#line_3"], { rotate: 0, }, "0")
        .to(["#line_2"], { autoAlpha: 1 }, "0.25")
        .to(["#line_1"], { y: 0 }, "0.25")
        .to(["#line_3"], { y: 0 }, "0.25");
};
const initMenu = () => {
    burger.addEventListener("click", () => {
        if (menu_state) {
            close_menu();
        }
        else {
            open_menu();
        }
        menu_state = !menu_state;
    });
    window.addEventListener('scroll', () => {
        const scrollTopPosition = window.scrollY;
        if (menu_state)
            return;
        if (window.location.href.includes("/location/") || window.location.href.includes("/rental/"))
            return;
        if (scrollTopPosition == 0) { //Menu appear at top
            header.classList.remove("scrollView");
            gsap.to(header, {
                y: 0,
                delay: 0.5
            });
            return;
        }
        if (scrollTopPosition > lastScrollTop && scrollTopPosition > offset) { //Menu and go-up dissapear on scroll down
            gsap.to(header, {
                y: isMobile ? -90 : -180,
            });
            gsap.to(scroll_up, {
                x: "100%"
            });
        }
        else if (scrollTopPosition > offset && scrollTopPosition < lastScrollTop) { //Menu and go-up appear on scroll up
            header.classList.add("scrollView");
            gsap.to(header, {
                y: 0,
            });
            gsap.to(scroll_up, {
                x: "-1rem"
            });
        }
        lastScrollTop = scrollTopPosition <= 0 ? 0 : scrollTopPosition;
    }, false);
};
export default initMenu;
